import axios from "axios";
import { API } from "../../const";
import { normParam, serverTime } from "@/tools";

const M_API = API;
const store = {
  namespaced: true,
  state: {
    instansi_aktif: null,
    instansi_id: null,
    instansis: [],
    permission: [],
    diklats: [],
  },
  getters: {
    instansis(state) {
      return state.instansis;
    },
    instansi_aktif(state) {
      return state.instansi_aktif;
    },
    instansi(state) {
      return state.instansi;
    },
    permission(state) {
      return state.permission;
    },
    diklats(state) {
      return state.diklats;
    },
    instansi_id(state) {
      return state.instansi_id;
    },
  },
  mutations: {
    pilihInstansi(state, instansi_aktif) {
      state.instansi_aktif = instansi_aktif;
    },
    setInstansi(state, val) {
      state.instansi_aktif = val;
    },
    setInstansiId(state, val) {
      state.instansi_id = val;
    },
    setInstansis(state, val) {
      state.instansis = val;
    },
  },
  actions: {
    // eslint-disable-next-line
    get({ commit, state }, params) {
      return axios
        .get(`${M_API}/instansi${normParam(params)}`, {
          params: {
            progress: true,
          },
        })
        .then((res) => {
          commit("setInstansis", res.data);
          commit("main/setTotalInstansi", res.data.total, {
            root: true,
          });
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    // eslint-disable-next-line
    getTokenSSO(_, obj) {
      return axios
        .post(`https://paspor-dev.simpkb.id/cas/gettoken`, obj)
        .then((res) => {
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    // eslint-disable-next-line
    pesertaTuntas(_, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/peserta_tuntas`, {
          params: {
            progress: true,
          },
        })
        .then((res) => {
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    // eslint-disable-next-line
    config({ commit }, params) {
      return axios
        .get(`${M_API}/konfigurasi${normParam(params)}`, {
          params: {
            progress: false,
          },
        })
        .then((res) => {
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    // eslint-disable-next-line
    getInformasi(_, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/informasi`, {})
        .then((res) => {
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKelola({ commit }, params) {
      return axios
        .get(`${M_API}/kelola/instansi${normParam(params)}`, {
          params: {
            progress: true,
          },
        })
        .then((res) => {
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    // eslint-disable-next-line
    sync(_, { instansi_id }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/sync`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    // eslint-disable-next-line
    getInstansi(_, params) {
      return axios
        .get(`${M_API}/organisasi${normParam(params)}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    detail(_, id_instansi) {
      return axios
        .get(`${M_API}/instansi/${id_instansi}`, {
          params: {
            progress: true,
          },
        })
        .then((res) => {
          res.data.server_time = serverTime(res);
          return res.data;
        })
        .catch((err) => Promise.reject(err));
    },
    profil(_, instansi_id) {
      return axios.get(`${M_API}/instansi/${instansi_id}`).then((res) => {
        return res.data;
      });
    },
    akses({ state }, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/akses`, {
          params: {
            progress: false,
          },
        })
        .then((res) => {
          state.permission = res.data;
        });
    },

    switchInstansi({ state, commit, dispatch }, instansi_id) {
      // cek apakah perlu load ulang instansi
      if (state.instansi_id == instansi_id) {
        return state.instansi_aktif;
      } else {
        return dispatch("detail", instansi_id).then((res) => {
          // reject jika instansi tidak ditemukan
          if (res.id) {
            state.instansi_aktif = res;
            state.instansi_id = res.id;
            commit("main/noInstansi", false, {
              root: true,
            });
          } else {
            commit("main/noInstansi", true, {
              root: true,
            });
            return Promise.reject();
          }
        });
      }
    },

    form(_, obj) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${obj.id}`, obj)
          .then((res) => {
            return res;
          })
          .catch((e) => e);
      } else {
        return axios
          .post(`${M_API}/instansi`, obj)
          .then((res) => {
            return res;
          })
          .catch((e) => e);
      }
    },
    drop(_, instansi_id) {
      return axios.delete(`${M_API}/instansi/${instansi_id}`).then((res) => {
        return res.data;
      });
    },
  },
};

export default store;
